import React, { Component } from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import Link from 'react-router-dom/Link';
import Card from 'react-bootstrap/Card';

export class AboutPage extends Component {
  render() {
    return (
      <div className="container">
        <Card>
          <Jumbotron>
            <Container>
              <h1>About</h1>
              <p>
                In short, we help users and devs find each other.
              </p>
              <p>
                Users can quickly find the indie game or indie product they want.
              </p>
              <p>
                Devs can enjoy being found after pouring the hard work into building
                their product as well as setting up a dedicated QA and feedback page.
              </p>
              <hr />
              <h5>Our philosophy</h5>
              <p>
                {' '}
                You surely must have one wondered at one point, "Hey does a
                software product exist to do this specific thing? Oh boy, it
                sucks to do it manually!" OR "Hey, it would be really cool if a
                game like this existed!"
              </p>
              <p>
                {' '}
                Well, in our evolving world, yes! A product like that -- an app,
                a website or a dekstop app -- probably exists, but you could not
                find it as it was buried in Google's search results.{' '}
              </p>
              <p>
                {' '}
                In most cases, the developer did not have the budget to conduct
                expensive SEO to get their product out to you.{' '}
              </p>
              <p>
                {' '}
                We aim to change that through creating an easy but comprehensive
                search platform to find these software products.{' '}
              </p>
              <p>
                {' '}
                Developers can upload their products with{' '}
                <strong> custom categories </strong> and users can search for
                them, so users can search for the exact indie product they want.
              </p>
              <p>
                This indie directory helps to link both sides in a meaningful way.
              </p>
              <p> This is coupled with the features below: </p>
              <ul>
                <li> Dedicated category-based searching: search by what the product does </li>
                <li> Objective + subjective reviews: plus, users can leave feedback as well </li>
                <li> QAs: each indie page contains a question-answer service, get answers from the dev or other users </li>
              </ul>
              {/* TODO: Add carousel */}

              <p>
                To see how this helps you, visit the link below depending on how
                you intend to use the platform. Perhaps, you may be both a user
                and a dev!{' '}
              </p>
              <ul>
                <li>
                  <Link to="/users">For users</Link>
                </li>
                <li>
                  <Link to="/developers">For developers</Link>
                </li>
              </ul>
            </Container>
          </Jumbotron>
        </Card>
      </div>
    );
  }
}

export default AboutPage;
